import ActionConstants from '../constants/actions';

const initialState = {
  allRoleGroupsLoading: false,
  allRoleGroupsFetched: false,
  allRoleGroupsError: '',
  allRoleGroupsResponse: null,

  // Create role flow
  createRoleLoading: false,
  createRoleFeedback: null, // { type: 'success' | 'error', message? }

  // Edit role flow
  editRoleLoading: false,
  editRoleFeedback: null, // { type: 'success' | 'error', message? }

  // Fetch role details (for edit pre-population)
  getRoleLoading: false,
  getRoleData: null,
  getRoleError: '',
};

export default function rolesReducer(state = initialState, action){
  switch (action.type) {
    case ActionConstants.RoleGroupsConstants.GET_ALL_ROLE_GROUPS_INIT: {
      return {
        ...state,
        allRoleGroupsLoading: true,
        allRoleGroupsError: '',
      };
    }
    case ActionConstants.RoleGroupsConstants.GET_ALL_ROLE_GROUPS_SUCCESS: {
      return {
        ...state,
        allRoleGroupsLoading: false,
        allRoleGroupsFetched: true,
        allRoleGroupsResponse: action.payload,
        allRoleGroupsError: '',
      };
    }
    case ActionConstants.RoleGroupsConstants.GET_ALL_ROLE_GROUPS_ERROR: {
      return {
        ...state,
        allRoleGroupsLoading: false,
        allRoleGroupsFetched: true,
        allRoleGroupsError: action.payload,
      };
    }

    // ── Create role group ──────────────────────────────────────────────────
    case ActionConstants.RoleGroupsConstants.CREATE_ROLE_GROUP_LOADING: {
      return {
        ...state,
        createRoleLoading: true,
        createRoleFeedback: null,
      };
    }
    case ActionConstants.RoleGroupsConstants.CREATE_ROLE_GROUP_SUCCESS: {
      return {
        ...state,
        createRoleLoading: false,
        createRoleFeedback: { type: 'success' },
      };
    }
    case ActionConstants.RoleGroupsConstants.CREATE_ROLE_GROUP_ERROR: {
      return {
        ...state,
        createRoleLoading: false,
        createRoleFeedback: { type: 'error', message: action.payload },
      };
    }
    case ActionConstants.RoleGroupsConstants.CLEAR_CREATE_ROLE_GROUP_FEEDBACK: {
      return {
        ...state,
        createRoleFeedback: null,
      };
    }

    // ── Edit role group ────────────────────────────────────────────────────
    case ActionConstants.RoleGroupsConstants.EDIT_ROLE_GROUP_LOADING: {
      return {
        ...state,
        editRoleLoading: true,
        editRoleFeedback: null,
      };
    }
    case ActionConstants.RoleGroupsConstants.EDIT_ROLE_GROUP_SUCCESS: {
      return {
        ...state,
        editRoleLoading: false,
        editRoleFeedback: { type: 'success' },
      };
    }
    case ActionConstants.RoleGroupsConstants.EDIT_ROLE_GROUP_ERROR: {
      return {
        ...state,
        editRoleLoading: false,
        editRoleFeedback: { type: 'error', message: action.payload },
      };
    }
    case ActionConstants.RoleGroupsConstants.CLEAR_EDIT_ROLE_GROUP_FEEDBACK: {
      return {
        ...state,
        editRoleFeedback: null,
      };
    }

    // ── Get role group details ─────────────────────────────────────────────
    case ActionConstants.RoleGroupsConstants.GET_ROLE_GROUP_LOADING: {
      return {
        ...state,
        getRoleLoading: true,
        getRoleData: null,
        getRoleError: '',
      };
    }
    case ActionConstants.RoleGroupsConstants.GET_ROLE_GROUP_SUCCESS: {
      return {
        ...state,
        getRoleLoading: false,
        getRoleData: action.payload,
        getRoleError: '',
      };
    }
    case ActionConstants.RoleGroupsConstants.GET_ROLE_GROUP_ERROR: {
      return {
        ...state,
        getRoleLoading: false,
        getRoleError: action.payload,
      };
    }
    case ActionConstants.RoleGroupsConstants.CLEAR_GET_ROLE_GROUP: {
      return {
        ...state,
        getRoleLoading: false,
        getRoleData: null,
        getRoleError: '',
      };
    }

    default:
      return state;
  }
}
